import { ADMIN_ROUTES } from 'constants/routes';
import { SUPPLIER_OFFER_SOURCE, SUPPLIER_OFFER_TYPE, SupplierOfferType } from 'models/SupplierOffer';

export const useChartNavigation = () => {
  const handleDotClick = (data: any) => {
    // Extract payload data - try multiple possible structures
    let payload = data?.payload || data;

    // If payload doesn't have the expected properties, try alternative structures
    if (!payload?.price && !payload?.supplierOfferId && !payload?.sourceId) {
      // Check if data is in a different structure (e.g., event.target.props)
      payload = data?.props?.payload || data?.target?.props?.payload || data;
    }

    // Check if we have valid navigation data
    const sourceId = payload?.supplierOfferId || payload?.sourceId;
    const type: SupplierOfferType = payload?.supplierOfferType || 'NONE';
    const price = payload?.price || 0;
    const source = payload?.source;

    // Only navigate if we have a valid source ID, price > 0, and it's not a "No Data" entry
    if (sourceId && price > 0 && source !== 'No Data') {
      window.open(
        ADMIN_ROUTES.supplierOffer.supplierOfferUpdate
          .replace(':type', SUPPLIER_OFFER_TYPE[type])
          .replace(':source', SUPPLIER_OFFER_SOURCE.MAIN)
          .replace(':supplierOfferId', sourceId),
        '_blank'
      );
    } else {
      console.log('No navigation available for this data point:', payload);
    }
  };

  return {
    handleDotClick,
  };
};
